import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import axios from "axios";
import {useNavigate } from "react-router-dom";
import { productDescriptions } from "./data/plans";
import { auth, db } from "./firebase";
import { doc, updateDoc, increment } from "firebase/firestore";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

function Purchase() {
    const stripe = useStripe();
    const elements = useElements();
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState("");
    const [loading, setLoading] = useState(false);
    const [clientSecret, setClientSecret] = useState("");
    const planId = searchParams.get("planId");
    const navigate = useNavigate();
    const product = productDescriptions[planId];

    useEffect(() => {

    const fetchClientSecret = async () => {
            if (!planId || !product) return;

            try {
                const res = await axios.post(process.env.REACT_APP_API_URL+"/create-payment-intent", {
                    planId: planId
                });
                setClientSecret(res.data.clientSecret);
            } catch (err) {
                setStatus("❌ Error preparing payment.");
            }
        };
        fetchClientSecret();
    }, [planId]);

    const cardStyle = {
        style: {
            base: {
                fontSize: '16px',
                color: '#333',
                '::placeholder': {
                    color: '#999',
                },
                fontFamily: 'inherit',
            },
            invalid: {
                color: '#e5424d',
            },
        },
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("");
        setLoading(true);

        try {
            const result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: elements.getElement(CardElement),
                },
            });

            if (result.error) {
                setStatus("❌ " + result.error.message);
            } else if (result.paymentIntent.status === "succeeded") {
                const user = auth.currentUser;

                if (!user) {
                    setStatus("❌ Not authenticated.");
                    return;
                }

                // Update Firestore credits or subscription
                const userRef = doc(db, "users", user.uid);
                const amount = product.type === "credit" ? product.amount : 0; // map based on planId if needed

                await updateDoc(userRef, {
                    ...(product.type === "credit"
                        ? { balance: increment(amount) }
                        : { type: "PRO" }),
                });
                await addDoc(collection(db, "user_activity"), {
                    uid: user.uid,
                    last_purchase_amount: product.type === "credit" ? amount : product.amount,
                    planId: planId,
                    last_purchase_date: serverTimestamp()
                });

                navigate("/payment-success", {
                    state: {
                        name: product.name,
                        price: product.price,
                        type: product.type,
                        amount,
                    },
                });
                setStatus("✅ Payment successful! You will receive your credits shortly.");

            }
        } catch (err) {
            setStatus("❌ Payment error: " + err.message);
        }

        setLoading(false);
    };

    return (
        <div className="purchase-container">
            <div className="purchase-card">
                <div className="checkout-logos">
                    <img src="/scrub_logo.png" alt="ScrubMail" className="scrub-logo" />
                    <img src="/scrub_logo.png" alt="Stripe" className="stripe-logo" />
                    </div>
                <div className="checkout-logoss"></div>

                <h2 className="checkout-title">Secure Checkout</h2>



                {product ?(
                    <>
                        <p className="checkout-subtitle">You're purchasing:</p>
                        <div className="product-box">
                            <p><strong>{product.name}</strong></p>
                            <p className="price">{product.price}</p>
                            <p className="credit-type">Includes {product.amount} email credits</p>
                        </div>

                        <form onSubmit={handleSubmit} className="purchase-form">
                            <h3>Card Information</h3>
                            <div className="card-element-wrapper">
                                <CardElement options={cardStyle}/>
                            </div>

                            <button
                                type="submit"
                                disabled={!stripe || loading}
                                className="purchase-button"
                            >
                                {loading ? "Processing..." : "Pay "+product.price}
                            </button>
                            <p className="secure-note">
                                🔒 Secured with Stripe · No card info is stored on our servers
                            </p>
                            {status && <p className="purchase-status">{status}</p>}
                        </form>
                    </>
                ) : (
                    <p>❌ Invalid plan selected.</p>
                )}
            </div>
        </div>
    );
}

export default Purchase;